import React from "react";
import { Quote } from "lucide-react";

const items = [
  {
    q: "We had constant overflow issues in a 22-floor tower. After Aquamatic's AquaTower CX, we haven't logged a single incident in 18 months.",
    who: "R. Menon",
    role: "Facility Head, Prestige Skywoods",
  },
  {
    q: "Their engineers integrated our factory pumps with our SCADA in three days. Fantastic support and truly rugged hardware.",
    who: "Kavita S.",
    role: "Plant Manager, Zenith Chemicals",
  },
  {
    q: "We upgraded the water system in a district hospital block. Zero downtime, and the app-based monitoring is a game-changer.",
    who: "Dr. Anand P.",
    role: "Superintendent, District Hospital",
  },
];

export default function Testimonials() {
  return (
    <section className="border-b border-zinc-200 bg-[#F4F4F5]">
      <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <div className="max-w-3xl mb-14">
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#002FA7] mb-4">
            /// Client Voices
          </div>
          <h2 className="text-4xl sm:text-5xl font-semibold tracking-tight leading-tight">
            Words from the field.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <div key={i} className="bg-white border border-zinc-300 p-8 shadow-hard">
              <Quote className="w-6 h-6 text-[#FF5F1F] mb-6" />
              <p className="text-zinc-800 leading-relaxed">{t.q}</p>
              <div className="mt-8 pt-6 border-t border-zinc-200">
                <div className="font-semibold">{t.who}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">
                  {t.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
